module.exports = __webpack_public_path__ + "img/black-user-avatar.2f55fae1.png";